"use client";
import React from "react";
import PropTypes from "prop-types";

const TableCard = ({header, children}) => (
  <div className="p-3 rounded-lg bg-white shadow-[0px_0px_20px_rgba(0,0,0,0.06)]">
    { header && (
      <div className="pb-3">
        {header}
      </div>
    )}
    <div className="border rounded">
      {children}
    </div>
  </div>
);

TableCard.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
};

export default TableCard;
